import Modal from 'react-bootstrap/Modal';

function ModalWrapper(props) {
    // console.log(props)
    // console.log(props.heading)
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            {/* <Modal.Header closeButton>
            </Modal.Header>  */}
            <Modal.Title id="contained-modal-title-vcenter">
                {props.heading}
            </Modal.Title>
            <button type="button" className="btn-close" aria-label="Close" onClick={props.onHide}></button>
            <Modal.Body>
                {props.children}
            </Modal.Body>
            {/* <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer> */}
        </Modal>
    );
}

export default ModalWrapper